export const selectReducer = (state) => state.myTemplateManagement;

export const selectMyTemplate = (state) =>
  selectReducer(state) ? selectReducer(state).get('myTemplate') : undefined;
